<template>
<div>
    
    <v-container fluid grid-list-md px-0>
        <v-layout row wrap>
            <v-flex xs12 clas="dashboard">
                    <div>
                        <v-layout row wrap>
                            <v-flex sm12 md12>
                                <v-layout row wrap>
                                    <v-flex xs12 sm12 md6>
                                        <TodaysVisits />
                                    </v-flex>
                                    <v-flex xs12 sm12 md6 v-if="this.role!='Office Admin'">
                                        <TodaysPendingregistration/>
                                    </v-flex>
                                    <v-flex xs12 sm12 md6 v-if="this.role=='Office Admin'">
                                        <TodaysVipVisits/>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                     <div>
                        <v-layout row wrap>
                            <v-flex sm12 md12>
                                <v-layout row wrap>
                                    <v-flex xs12 sm12 md6>
                                        <vuechart/>
                                    </v-flex>
                                    <v-flex xs12 sm12 md6>
                                       
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import TodaysVisits from '../DashboardComponents/TodaysVisits'
import TodaysVipVisits from '../DashboardComponents/TodaysVipVisits'
import TodaysPendingregistration from '../DashboardComponents/TodaysPendingregistration'
import vuechart from '../DashboardComponents/vuechart'
import {
    Bar
} from 'vue-chartjs';
export default {
    components: {
        vuechart,
        TodaysVipVisits,
        TodaysVisits,
        TodaysPendingregistration,

    },
    data: () => {
        return {
            loaders: {
                detail_loader: false
            },
            role: '',

        }

    },
    mounted() {
        this.role = localStorage.getItem('visitor_management_role');
    },

};
</script>
